export default {
    default: {
        reviews: "Reviews ReviewCarousel relative h-auto bg-red overflow-hidden lg:pl-80 lg:h-auto",
        prevButton: "flickity-button flickity-prev-next-button previous",
        nextButton: "flickity-button flickity-prev-next-button next",
    },
    NDReview: {
        reviews: "Reviews ReviewCarousel relative h-auto bg-red overflow-hidden lg:pl-80 lg:h-auto NDReview",
        prevButton: "flickity-button flickity-prev-next-button previous",
        nextButton: "flickity-button flickity-prev-next-button next",

    },
    xoxoReview: {
        reviews: "Reviews ReviewCarousel relative h-auto bg-red overflow-hidden lg:pl-80 lg:h-auto xoxo-review",
        prevButton: "flickity-button flickity-prev-next-button previous",
        nextButton: "flickity-button flickity-prev-next-button next",
    },
    kokeshiReview: {
        reviews: "kokeshiReview Reviews ReviewCarousel relative h-auto bg-red overflow-hidden lg:pl-80 lg:h-auto",
        prevButton: "flickity-button flickity-prev-next-button previous",
        nextButton: "flickity-button flickity-prev-next-button next",
    },
    ReviewCard: {
        reviewCard: "ReviewCard w-8/12 pl-25 py-100 lg:mt-0 h-auto lg:h-auto lg:pt-145 lg:pb-160 lg:w-5/12",
        ReviewCardOne: "ReviewCard ReviewCardOne w-full pl-25 py-100 lg:mt-0 h-auto lg:h-auto lg:pt-145 lg:pb-160 ",
        ReviewSectionRating: "ReviewSectionRating",
        description: "header4 text-white",
        reviewerName: "eyebrow-small uppercase text-white mt-48",
        source: "eyebrow-small uppercase text-white mt-8 lg:mt-10",
        prevButton: "flickity-button flickity-prev-next-button previous",
        nextButton: "flickity-button flickity-prev-next-button next",
    }   
    
}